import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { PrizepicksSwitch } from '@library/components/switches';
import { Tooltip } from '@library/components/tooltip/Tooltip';
import { useBulkStatusActions } from '@bo-hooks/simulations/useBulkStatusActions';

export interface BulkStatusActionsProps {
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
  simProjections: Array<GamePlayerProjectionTrading>;
  statTypeName: string;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}

export const BulkStatusActions = ({
  newAndChangedProjections,
  simProjections,
  statTypeName,
  updateProjection
}: BulkStatusActionsProps) => {
  const { allEnabled, handleBulkStatusChange } = useBulkStatusActions({
    newAndChangedProjections,
    simProjections,
    updateProjection
  });

  return (
    <div className="place-self-end pr-4">
      <Tooltip
        text={
          allEnabled
            ? 'Click to Disable All Projections for this Stat Type'
            : 'Click to Enable All Projections for this Stat Type'
        }
      >
        <PrizepicksSwitch
          active={allEnabled}
          disabled={false}
          statType={statTypeName}
          handleChange={handleBulkStatusChange}
        />
      </Tooltip>
    </div>
  );
};
